<template>
  <footer class="pageFooter">
    <p>Copyright 2018</p>
  </footer>
</template>

<script>
export default {};
</script>

<style>
.pageFooter {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  padding-top: .8rem;
  padding-left: 1rem;
  line-height: .4rem;
  font-size: .7rem;
  display: flex;
  background-color: gray;
  color: white;
}
</style>